import { render, staticRenderFns } from "./QsButton.vue?vue&type=template&id=79bbe4c6&scoped=true&"
import script from "./QsButton.vue?vue&type=script&lang=js&"
export * from "./QsButton.vue?vue&type=script&lang=js&"
import style0 from "./QsButton.vue?vue&type=style&index=0&id=79bbe4c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bbe4c6",
  null
  
)

export default component.exports